export default __webpack_public_path__ + "static/media/AssortmentFiltering.d38d27cf.png";